/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
import { FormEditCreateUpdatePaymentTypeFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/payment-type/create-update/form-edit-create-update-payment-type-field-dialog.component';
/* eslint-enable */

export class FormEditPaymentTypeFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(private injector: Injector,
              private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdatePaymentTypeFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdatePaymentTypeFieldDialogComponent)
      .create(this.injector);
  }

}
